<template>
  <div class="formily-todo" :class="{ 'enable-width-setting': enableWidthSetting }">
    <FormProvider :form="form" v-loading.lock.fullscreen="form.loading">
      <FormLayout :labelCol="0" :wrapperCol="0" :labelWidth="120">
        <SchemaField :schema="formSchema || {}" />
      </FormLayout>
    </FormProvider>
  </div>
</template>

<script>
import { createForm } from '@formily/core';
import Space from './Space';
import Input from './Input';
import Upload from './Upload';
import Picker from './Picker';
import TimePicker from './TimePicker';
import Quill from '@/components/Formily/quill';
import Text from './text';
import HtmlText from './htmlText.ts';
import Link from './link';
import Images from './images.ts';
import Button from './button';
import FormTab from './formTab';
import Scanner from './scanner.js';
import MoveTabNavigation from './MoveTabNavigation.js';

import Export from './Export.vue';
import Import from './import.ts';
import Location from './location.ts';
import Contact from './contact.ts';
import FormCollapse from './FormCollapse.js';
import Signature from './signature.ts';
import ArrayCards from './card.js';
import BackTop from './backTop.js';
import TimeButton from './timeButton.ts';
import NewCheckbox from './newCheckbox.ts';
import NewUpload from './newUpload.js';
import EmailSelect from './emailSelect.ts';
import ToStorageTable from '@/components/Formily/toStorageTable.ts';
import OutboundMeasurementTable from '@/components/Formily/OutboundMeasurementTable.ts';
import OutgoingPieceworkTable from '@/components/Formily/OutgoingPieceworkTable.ts';
import undercarriageGoBackTable from '@/components/Formily/undercarriageGoBackTable.ts';
import Template from '@/components/Formily/FormilyTemplate.ts';
import { isEqual } from 'lodash';
import flowTable from '@/views/todo-details-paeg/assetFlow/flowTable.ts';
import {
  formilyStepper,
  formilyCascader,
  formilyTimePicker,
  formilyFormItem,
  formilySwitch,
  formilyFormGrid,
} from './index.ts';
import CommonSelect from '@/components/Formily/CommonSelect';
import UserSelect from '@/components/Formily/userSelect';
import VoiceAssistant from '@/components/VoiceAssistant/index.vue';
import { FormProvider, createSchemaField } from '@formily/vue';
import ServerEntryTable from '@/components/Formily/ServerEntryTable.ts';
import ServerOutboundTable from '@/components/Formily/ServerOutboundTable.ts';
import FacilityAssetEntryTable from '@/components/Formily/FacilityAssetEntryTable.ts';
import FacilityAssetReleaseTable from '@/components/Formily/FacilityAssetReleaseTable.ts';
import Steps from './steps.ts';
import networkOutboundTable from '@/components/Formily/networkOutboundTable.ts';
import assetLocationVerificationTable from '@/components/Formily/assetLocationVerificationTable.ts';
import serverDirectAllocationTable from '@/components/Formily/serverDirectAllocationTable.ts';
import AssetesCascader from '@/components/Formily/assetesCascader.ts';
import idcdbPaginatedTable from '@/views/todo-details-paeg/equipmentManagement/components/idcdbPaginatedTable.vue';
import PlanTable from '@/components/Formily/planTable.ts';
import HotTable from '@/components/Formily/HotTable.ts';
import {
  Form,
  Group,
  Submit,
  // ArrayTable,
  // Input,
  // Editable,
  PreviewText,
  Checkbox,
  // FormGrid,
  // Select,
  // Picker,
  // ArrayItems,
  // Space,
  FormLayout,
  // Reset,
  // Cascader,
  Radio,
  // Password,
  // TimePicker,
  // DatetimePicker,
} from '@formily/vant';
import { ArrayTable } from '@formily/element';
// import Breadcrumb from '@/components/Breadcrumb';
import { Message, Dialog, MessageBox } from 'element-ui';
import { getDataByNbrokerUrl } from '@/api/tickets/ticketsApi.js';
import dayjs from 'dayjs';
import store from '@/store';
import NewArrayTable from './newArrayTable';

import NewArrayCards from './newcard';

import MobileArrayCards from './mobilecard.js';
import CountDownTimeButton from './CountDownTimeButton.ts';

/**
 * 计算 enableWidthSetting 配置
 * 从七彩石配置中读取 enable_card_refresh_key，决定是否启用宽度设置
 * @returns {boolean} 是否启用宽度设置
 */
function calculateEnableWidthSetting() {
  let enableWidthSetting = false;
  try {
    if (store?.getters?.getConfigItem) {
      // 获取配置并解析为 JSON 格式
      const configStr = store.getters.getConfigItem('enable_card_refresh_key');

      if (configStr) {
        try {
          const config = JSON.parse(configStr);

          // 如果 open 为 false，则功能关闭
          if (config.open === false) {
            enableWidthSetting = false;
          } else if (config.open === true) {
            // 如果 open 为 true，检查 key 数组
            const keyArray = Array.isArray(config.key) ? config.key : [];

            if (keyArray.length === 0) {
              // key 数组为空，对所有流程生效
              enableWidthSetting = true;
            } else {
              // key 数组不为空，只对相应流程生效
              const currentProcessKey = store.state.config?.ProcessDefinitionKey || '';

              if (currentProcessKey && keyArray.includes(currentProcessKey)) {
                enableWidthSetting = true;
              } else {
                enableWidthSetting = false;
              }
            }
          }
        } catch (parseError) {
          // JSON 解析失败，降级为旧的布尔值逻辑
          console.warn('[formilyTodoForm-new] 配置解析失败，降级为布尔值判断', parseError);
          enableWidthSetting = false;
        }
      }
    }
  } catch (e) {
    // 配置读取失败，默认关闭
    console.warn('[formilyTodoForm-new] 读取七彩石配置失败', e);
  }
  return enableWidthSetting;
}

const fields = createSchemaField({
  components: {
    Form,
    Submit,
    FormItem: formilyFormItem,
    ArrayTable,
    ArrayCards,
    NewArrayTable,
    NewArrayCards,
    MobileArrayCards,
    Input,
    // Editable,
    PreviewText,
    Checkbox,
    FormGrid: formilyFormGrid,
    Select: Picker,
    // ArrayItems,
    Space,
    FormLayout,
    // Reset,
    // Text,
    // Link,
    // Button,
    Radio,
    // Password,
    TimePicker,
    DatePicker: formilyTimePicker,
    TextArea: Input,
    Switch: formilySwitch,
    Password: Input,
    FormCollapse,
    Location,
    // FormTab,
    // ArrayCards,
    Template,
    Upload,
    Cascader: formilyCascader,
    Quill,
    Text,
    Link,
    FormTab,
    Button,
    NumberPicker: formilyStepper,
    UserSelect,
    CommonSelect,
    Images,
    Scanner,
    MoveTabNavigation,
    Signature,
    Export,
    Import,
    Contact,
    BackTop,
    TimeButton,
    NewCheckbox,
    NewUpload,
    ToStorageTable,
    OutboundMeasurementTable,
    OutgoingPieceworkTable,
    undercarriageGoBackTable,
    // ArrayCollapse,
    // Quill,
    // UserSelect,
    // CommonSelect,
    HtmlText,
    ServerEntryTable,
    ServerOutboundTable,
    flowTable,
    FacilityAssetReleaseTable,
    FacilityAssetEntryTable,
    Steps,
    assetLocationVerificationTable,
    serverDirectAllocationTable,
    networkOutboundTable,
    AssetesCascader,
    idcdbPaginatedTable,
    VoiceButton: VoiceAssistant,
    CountDownTimeButton,
    PlanTable,
    EmailSelect,
    HotTable
  },
  scope: {
    ding: document.querySelector('#ding-mp3'),
    alarm: document.querySelector('#alarm-mp3'),
    finish: document.querySelector('#finish-mp3'),
    currentUser: sessionStorage.getItem('userid') || '',
    Message,
    Dialog,
    MessageBox,
    getDataByNbrokerUrl,
    dayjs,
    rainbowData: store.state.config,
  },
});

export default {
  components: { FormLayout, FormProvider, ...fields },
  props: ['schema', 'values', 'disabled'],
  data() {
    const form = createForm();
    const formSchema = this.formatSchema(this.schema);
    // const formCollapse = FormCollapse.createFormCollapse()
    return {
      // qqq,
      form,
      formSchema,
      // formCollapse,
      enableWidthSetting: false,
    };
  },
  watch: {
    schema(newVal) {
      this.formSchema = this.formatSchema(newVal);
    },
    values: {
      handler(newVal, oldVal) {
        if (isEqual(newVal, oldVal)) return;
        const val = this.formatValue(newVal);
        this.form.setValues(val, 'deepMerge');
      },
      deep: true,
    },
  },
  created() {
    // 计算 enableWidthSetting 的值
    this.enableWidthSetting = this.getEnableWidthSetting();

    // 监听 Radio 字段的 enum 变化，兼容 { label, value } 格式
    // 仅当 enableWidthSetting 为 true 时才启用
    if (this.enableWidthSetting) {
      this.form.subscribe(({ payload }) => {
        const field = payload;
        if ((field?.component?.[0] === 'Radio' || field?.component?.[0] === 'Radio.Group') && Array.isArray(field.dataSource)) {
          field.dataSource = field.dataSource.map((item) =>
            typeof item === 'object' && item.value !== undefined && item.name === undefined
              ? { ...item, name: item.value }
              : item
          );
        }
      });
    }
  },
  mounted() {
    const val = this.formatValue(this.values);
    this.form.setValues(val);
  },
  methods: {
        /**
     * 获取 enableWidthSetting 配置
     * 从七彩石配置中读取 enable_card_refresh_key，决定是否启用宽度设置
     * @returns {boolean} 是否启用宽度设置
     */
    getEnableWidthSetting() {
      return calculateEnableWidthSetting();
    },

    /**
     * 将自增表格转换为自增卡片的工具函数
     * @param {Object} schema - 包含自增表格的 schema 对象
     * @returns {Object} 转换后的包含自增卡片的 schema 对象
     */
    convertArrayTableToArrayCards(schema) {
      if (!schema || !schema.properties || !store.getters.getConfigItem('convertCard')) {
        return schema;
      }

      const convertedSchema = JSON.parse(JSON.stringify(schema)); // 深拷贝

      // 递归遍历所有属性
      this._recursiveConvertArrayTable(convertedSchema.properties);

      return convertedSchema;
    },

    /**
     * 递归转换 ArrayTable 为 ArrayCards
     * @param {Object} properties - schema 的 properties 对象
     */
    _recursiveConvertArrayTable(properties) {
      if (!properties) return;

      Object.keys(properties).forEach((key) => {
        const property = properties[key];

        // 检查是否是 ArrayTable 组件
        if (property['x-component'] === 'ArrayTable' && property?.['x-component-props']?.convert) {
          // console.log('property', property);

          this._convertSingleArrayTable(property);
        }
        // 检查是否是 NewArrayTable 组件
        if (
          property['x-component'] === 'NewArrayTable' &&
          property?.['x-component-props']?.convert
        ) {
          this._convertSingleArrayTable(property);
        }

        // 递归处理嵌套的 properties
        if (property.properties) {
          this._recursiveConvertArrayTable(property.properties);
        }

        // 递归处理 items 中的 properties
        if (property.items && property.items.properties) {
          this._recursiveConvertArrayTable(property.items.properties);
        }
      });
    },

    /**
     * 转换单个 ArrayTable 为 ArrayCards
     * @param {Object} arrayTableProperty - ArrayTable 属性对象
     */
    _convertSingleArrayTable(arrayTableProperty) {
      // console.log('arrayTableProperty==>',arrayTableProperty);

      // 更改组件类型
      arrayTableProperty['x-component'] = 'MobileArrayCards';

      // 转换组件属性
      if (arrayTableProperty['x-component-props']) {
        const oldProps = arrayTableProperty['x-component-props'];
        // console.log('oldProps==>',oldProps);

        arrayTableProperty['x-component-props'] = {
          // title: oldProps.title || 'Title',
          title: oldProps.title || null,

          titleDesc: oldProps.titleDesc || '',
          convertCollapseBtn: oldProps.convertCollapseBtn,
          allCollapseBtn: oldProps.allCollapseBtn,
          defaultAllCollapsed: oldProps.defaultAllCollapsed,
          HorizontalVersion: oldProps.HorizontalVersion !== undefined ? oldProps.HorizontalVersion : true,
          // 移除分页配置，ArrayCards 不需要分页
        };
        // console.log('props==>', arrayTableProperty['x-component-props']);
      } else {
        arrayTableProperty['x-component-props'] = {
          // title: 'Title',
          title: null,

          titleDesc: oldProps.titleDesc || '',
        };
      }

      // 转换 items 结构
      if (arrayTableProperty.items && arrayTableProperty.items.properties) {
        const tableColumns = arrayTableProperty.items.properties;
        const cardProperties = {};
        const cardActions = {};

        // 按照原始x-index顺序排序列，保持ArrayTable.Column的原始顺序
        const sortedColumnKeys = Object.keys(tableColumns).sort((a, b) => {
          const indexA = tableColumns[a]['x-index'] || 0;
          const indexB = tableColumns[b]['x-index'] || 0;
          return indexA - indexB;
        });

        // 提取表格列并转换为卡片字段，保持原始顺序
        sortedColumnKeys.forEach((columnKey) => {
          const column = tableColumns[columnKey];

          if (
            column['x-component'] === 'ArrayTable.Column' ||
            column['x-component'] === 'NewArrayTable.Column'
          ) {
            // 检查列中是否包含需要跳过的组件
            let shouldSkipColumn = false;
            let hasActionComponents = false;

            if (column.properties) {
              Object.values(column.properties).forEach((field) => {
                // 检查是否包含ArrayTable.Index组件
                if (
                  field['x-component'] === 'ArrayTable.Index' ||
                  field['x-component'] === 'NewArrayTable.Index'
                ) {
                  shouldSkipColumn = true;
                }
                // 检查是否包含操作按钮组件
                if (
                  [
                    'ArrayTable.Remove',
                    'ArrayTable.MoveUp',
                    'ArrayTable.MoveDown',
                    'NewArrayTable.Remove',
                    'NewArrayTable.MoveUp',
                    'NewArrayTable.MoveDown',
                  ].includes(field['x-component'])
                ) {
                  hasActionComponents = true;
                  shouldSkipColumn = true;
                }
              });

              // 如果包含操作按钮，处理这些按钮但跳过列本身
              if (hasActionComponents) {
                Object.keys(column.properties).forEach((actionKey) => {
                  const action = column.properties[actionKey];
                  if (
                    action['x-component'] === 'ArrayTable.Remove' ||
                    action['x-component'] === 'NewArrayTable.Remove'
                  ) {
                    cardActions[`remove_${actionKey}`] = {
                      type: 'void',
                      'x-component': 'MobileArrayCards.Remove',
                      'x-designable-id': action['x-designable-id'] || `remove_${Date.now()}`,
                      'x-designable-source-name':
                        action['x-designable-source-name'] || 'MobileArrayCards.Remove',
                      'x-index': 2 + Object.keys(cardActions).length,
                    };
                  } else if (
                    action['x-component'] === 'ArrayTable.MoveUp' ||
                    action['x-component'] === 'NewArrayTable.MoveUp'
                  ) {
                    cardActions[`moveUp_${actionKey}`] = {
                      type: 'void',
                      'x-component': 'MobileArrayCards.MoveUp',
                      'x-designable-id': action['x-designable-id'] || `moveUp_${Date.now()}`,
                      'x-designable-source-name':
                        action['x-designable-source-name'] || 'MobileArrayCards.MoveUp',
                      'x-index': 2 + Object.keys(cardActions).length,
                    };
                  } else if (
                    action['x-component'] === 'ArrayTable.MoveDown' ||
                    action['x-component'] === 'NewArrayTable.MoveDown'
                  ) {
                    cardActions[`moveDown_${actionKey}`] = {
                      type: 'void',
                      'x-component': 'MobileArrayCards.MoveDown',
                      'x-designable-id': action['x-designable-id'] || `moveDown_${Date.now()}`,
                      'x-designable-source-name':
                        action['x-designable-source-name'] || 'MobileArrayCards.MoveDown',
                      'x-index': 2 + Object.keys(cardActions).length,
                    };
                  }
                });
              }
            }

            // 如果包含需要跳过的组件，跳过这个列
            if (shouldSkipColumn) {
              return;
            }

            // 获取列的标题
            // const columnTitle = column['x-component-props']?.title || 'Title';
            const columnTitle = column['x-component-props']?.title || null;

            // console.log('columnTitle==>', columnTitle);

            // 处理普通列
            if (column.properties) {
              // 按字段自身的 x-index 排序后再分配新的连续 x-index。
              // 不能直接用 Object.keys 的插入顺序：该顺序取决于 schema 的序列化来源，
              // 设计器保存、后端 map 序列化等环节都可能把键排成字母序，
              // 导致卡片字段顺序与 PC 端表格列顺序不一致（表现为移动端乱序）。
              const sortedFieldKeys = Object.keys(column.properties).sort((a, b) => {
                const fa = Number(column.properties[a]['x-index']);
                const fb = Number(column.properties[b]['x-index']);
                const na = Number.isNaN(fa);
                const nb = Number.isNaN(fb);
                // 两者都有 x-index：按 x-index 升序
                if (!na && !nb) return fa - fb;
                // 有 x-index 的排在前面，无 x-index 的保持原有相对顺序兜底
                if (na && !nb) return 1;
                if (!na && nb) return -1;
                return 0;
              });

              sortedFieldKeys.forEach((fieldKey) => {
                const field = column.properties[fieldKey];

                // 将字段添加到卡片属性中，并设置正确的title，保持原始的x-index
                cardProperties[fieldKey] = {
                  ...field,
                  // 如果字段本身没有title，使用列的title
                  title: field.title || columnTitle,
                  'x-decorator': [
                    'DatePicker',
                    'Select',
                    'TimePicker',
                    'Input',
                    'Input.TextArea',
                    'Cascader',
                    'Space',
                    'FormGrid',
                  ].includes(field['x-component'])
                    ? null
                    : 'FormItem',
                  // 保持原始列的x-index顺序
                  'x-index': column['x-index'] || 0,
                };
              });
            }
          } else if (
            column['x-component'] &&
            (column['x-component'].startsWith('ArrayTable.') ||
              column['x-component'].startsWith('NewArrayTable.'))
          ) {
            // 处理操作列中的按钮
            if (column.properties) {
              Object.keys(column.properties).forEach((actionKey) => {
                const action = column.properties[actionKey];
                if (
                  action['x-component'] === 'ArrayTable.Remove' ||
                  action['x-component'] === 'NewArrayTable.Remove'
                ) {
                  cardActions[`remove_${actionKey}`] = {
                    type: 'void',
                    'x-component': 'MobileArrayCards.Remove',
                    'x-designable-id': action['x-designable-id'] || `remove_${Date.now()}`,
                    'x-designable-source-name':
                      action['x-designable-source-name'] || 'MobileArrayCards.Remove',
                    'x-index': 2 + Object.keys(cardActions).length,
                  };
                } else if (
                  action['x-component'] === 'ArrayTable.MoveUp' ||
                  action['x-component'] === 'NewArrayTable.MoveUp'
                ) {
                  cardActions[`moveUp_${actionKey}`] = {
                    type: 'void',
                    'x-component': 'MobileArrayCards.MoveUp',
                    'x-designable-id': action['x-designable-id'] || `moveUp_${Date.now()}`,
                    'x-designable-source-name':
                      action['x-designable-source-name'] || 'MobileArrayCards.MoveUp',
                    'x-index': 2 + Object.keys(cardActions).length,
                  };
                } else if (
                  action['x-component'] === 'ArrayTable.MoveDown' ||
                  action['x-component'] === 'NewArrayTable.MoveDown'
                ) {
                  cardActions[`moveDown_${actionKey}`] = {
                    type: 'void',
                    'x-component': 'MobileArrayCards.MoveDown',
                    'x-designable-id': action['x-designable-id'] || `moveDown_${Date.now()}`,
                    'x-designable-source-name':
                      action['x-designable-source-name'] || 'MobileArrayCards.MoveDown',
                    'x-index': 2 + Object.keys(cardActions).length,
                  };
                }
              });
            }
          }
        });

        // 重构 items 结构为 ArrayCards 格式
        arrayTableProperty.items = {
          type: 'void',
          'x-designable-id':
            arrayTableProperty.items['x-designable-id'] || `card_item_${Date.now()}`,
          'x-designable-source-name':
            arrayTableProperty.items['x-designable-source-name'] || 'card_item',
          properties: {
            // 添加索引组件
            index: {
              type: 'void',
              'x-component': 'MobileArrayCards.Index',
              'x-designable-id': `index_${Date.now()}`,
              'x-designable-source-name': 'MobileArrayCards.Index',
              'x-index': 0,
            },
            // 添加字段容器
            fields: {
              type: 'object',
              'x-designable-id': `fields_${Date.now()}`,
              'x-designable-source-name': 'fields_container',
              properties: cardProperties,
              'x-index': 1,
            },
            // 添加操作按钮
            ...cardActions,
          },
        };

        // 处理 Addition 按钮
        if (arrayTableProperty.properties) {
          Object.keys(arrayTableProperty.properties).forEach((propKey) => {
            const prop = arrayTableProperty.properties[propKey];

            if (
              prop['x-component'] === 'ArrayTable.Addition' ||
              prop['x-component'] === 'NewArrayTable.Addition'
            ) {
              prop['x-component'] = 'MobileArrayCards.Addition';
            }
          });
        }
      }
    },

    /**
     * 批量转换 schema 中的所有 ArrayTable 为 ArrayCards
     * @param {Object} formSchema - 完整的表单 schema
     * @returns {Object} 转换后的 schema
     */
    batchConvertArrayTables(formSchema) {
      if (!formSchema) return formSchema;

      return this.convertArrayTableToArrayCards(formSchema);
    },

    /**
     * 应用转换后的 schema 到当前表单
     * @param {Object} newSchema - 新的 schema 对象
     */
    applyConvertedSchema(newSchema) {
      this.formSchema = this.formatSchema(newSchema);
      this.$forceUpdate();
    },

    /**
     * 获取转换后的 schema（不改变当前表单）
     * @returns {Object} 转换后的 schema
     */
    getConvertedSchema() {
      return this.convertArrayTableToArrayCards(this.schema);
    },

    /**
     * 直接转换当前表单的 ArrayTable 为 ArrayCards
     */
    convertCurrentFormArrayTables() {
      const convertedSchema = this.convertArrayTableToArrayCards(this.schema);
      this.applyConvertedSchema(convertedSchema);
      return convertedSchema;
    },
    formatValue(val) {
      const res = JSON.stringify(val, (key, value) => {
        if (Array.isArray(value)) {
          return value.map((item) => (item === null ? {} : item));
        }
        return value;
      });
      return JSON.parse(res);
    },
    recursiveDelete(obj, enableWidthSettingCache) {
      if (!obj) return;
      
      // 读取七彩石配置，决定是否启用宽度设置（带异常兜底）
      // 使用缓存避免每次递归调用都重新读取配置
      let enableWidthSetting = enableWidthSettingCache;
      
      if (enableWidthSetting === undefined) {
      enableWidthSetting = calculateEnableWidthSetting();
      }
      
      if (obj.properties) {
        this.recursiveDelete(obj.properties, enableWidthSetting);
      }
      Object.values(obj).map((property) => {
        if (property.properties) {
          this.recursiveDelete(property.properties, enableWidthSetting);
        }
        if (property.items) {
          this.recursiveDelete(property.items, enableWidthSetting);
        }
        if (
          [
            'DatePicker',
            'Select',
            'TimePicker',
            'Input',
            'Input.TextArea',
            'Cascader',
            'Space',
            'FormGrid',
          ].includes(property['x-component'])
        ) {
          // readPretty
          // console.log('recursiveDelete==>',property);
          if(property['x-component']=='Select'&&property['x-pattern'] === 'readPretty'){
            return;
          }
          this.removeDecorator(property);
        }
        if (
          !property.title &&
          [
            'ArrayTable',
            'ArrayCard',
            'NewArrayTable',
            'NewArrayCard',
            'MobileArrayCards',
            'ToStorageTable',
            'OutboundMeasurementTable',
            'OutgoingPieceworkTable',
            'undercarriageGoBackTable',
            'ServerEntryTable',
            'ServerOutboundTable',
            'flowTable',
            'FacilityAssetReleaseTable',
            'FacilityAssetEntryTable',
            'serverDirectAllocationTable',
            'assetLocationVerificationTable',
            'networkOutboundTable',
            'AssetesCascader',
          ].includes(property['x-component'])
        ) {
          this.removeDecorator(property);
        }
        if (
          ['Input.TextArea'].includes(property['x-component']) &&
          property['x-pattern'] === 'readPretty' &&
          !property?.title
        ) {
          property['x-component'] = 'Text';
        }
        if (property['x-component'] === 'ArrayTable.Column' && Object.values(obj).length > 2) {
          const decorator = property;
          // 根据配置决定是否使用动态宽度
          const getWidth = () => {
            if (enableWidthSetting && typeof window !== 'undefined') {
              // 配置启用时，根据屏幕尺寸动态计算
              const screenWidth = window.innerWidth;
              if (screenWidth >= 768) return 340; // 平板端和桌面端
              return 170; // 移动端
            }
            return 170; // 配置未启用或SSR时，固定返回170
          };
          decorator['x-component-props'] = {
            ...decorator['x-component-props'],
            width: decorator['x-component-props'].width || getWidth(),
          };
        }
        if (property['x-component'] === 'NewArrayTable.Column' && Object.values(obj).length > 2) {
          const decorator = property;
          // 根据配置决定是否使用动态宽度
          const getWidth = () => {
            if (enableWidthSetting && typeof window !== 'undefined') {
              // 配置启用时，根据屏幕尺寸动态计算
              const screenWidth = window.innerWidth;
              if (screenWidth >= 768) return 340; // 平板端和桌面端
              return 170; // 移动端
            }
            return 170; // 配置未启用或SSR时，固定返回170
          };
          decorator['x-component-props'] = {
            ...decorator['x-component-props'],
            width: decorator['x-component-props'].width || getWidth(),
          };
        }
      });
    },
    // 移动端会把字段的 FormItem 装饰器移除（见 recursiveDelete）。
    // 被移除装饰器的字段，其“表单项容器样式”（x-decorator-props.style）会随之失效，
    // 这里在移除装饰器的同时把容器样式合并到组件样式（x-component-props.style），
    // 使 ReactiveField 将其作为组件 style 应用到输入控件根节点（如文字颜色）。
    // 注意：只处理“本会被移除装饰器”的字段，不改变其它字段的 x-decorator-props 语义。
    removeDecorator(property) {
      property['x-decorator'] = null;
      const decoratorProps = property['x-decorator-props'];
      if (decoratorProps && decoratorProps.style) {
        property['x-component-props'] = {
          ...(property['x-component-props'] || {}),
          style: {
            ...((property['x-component-props'] && property['x-component-props'].style) || {}),
            ...decoratorProps.style,
          },
        };
      }
    },
    recursiveDisable(obj) {
      if (!obj) return;
      if (obj.properties) {
        this.recursiveDisable(obj.properties);
      }
      Object.values(obj).map((property) => {
        if (property.properties) {
          this.recursiveDisable(property.properties);
        }
        if (property.items) {
          const item = property;
          if (!['Export'].includes(item['component'])) {
            item['x-pattern'] = 'disabled';
            this.recursiveDisable(property.items);
          }
        }
        if (property['x-component']) {
          const item = property;
          if (!['Export'].includes(item['component'])) {
            item['x-pattern'] = 'disabled';
          }
        }
      });
    },
    formatSchema(val) {
      try {
        this.recursiveDelete(val.schema ? val.schema : val);
        this.disabled && this.recursiveDisable(val.schema ? val.schema : val);
        val = this.convertArrayTableToArrayCards(val.schema ? val.schema : val);
        const str = JSON.stringify(val, this.formatJson).replace(
          /\/relay\/api/g,
          '/relay/ifob/api'
        );
        const res = JSON.parse(str);
        console.log(res);
        if (res && res.schema) {
          return res.schema;
        }
        return res || {};
      } catch (e) {
        console.log(e);
        return {};
      }
    },
    formatJson(key, value) {
      if (key === 'labelWidth') return undefined;
      if (key === 'x-component' && value === 'Input.TextArea') return 'TextArea';
      if (key === 'enum' && Array.isArray(value))
        return value.map((item) =>
          typeof item === 'object' ? { ...item, name: item.name || item.value } : item
        );
      return value;
    },
    getValues() {
      return this.form.values;
    },
    async validate() {
      return await this.form.validate();
    },
    setValues(newVal) {
      const val = this.formatValue(newVal);
      this.form.setValues(val, 'deepMerge');
    },
    reset() {
      Object.values(this.form.fields).forEach((item) => item.reset && item.reset());
    },
  },
};
</script>

<style scoped lang="less">
.formily-todo {
  /deep/ .el-pagination {
    overflow: auto;
    margin: 0 18% 0 5%;
  }
  /deep/ .ql-picker-label {
    display: inline-flex;
    align-items: center;
  }
  /deep/ .ql-picker-options {
    z-index: 999;
  }
  /deep/ .ql-picker {
    display: inline-flex;
    align-items: center;
  }
  /deep/ .van-cell__value.van-cell__value--alone.van-field__value {
    overflow: auto;
  }
  /deep/ .formily-vant-preview-text::after,
  /deep/ .van-cell::after {
    display: block;
  }
  /deep/ .van-cell__value .van-radio-group,
  /deep/ .van-cell__value .van-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
  }
  /deep/ .van-field__label .van-cell {
    padding: 0;
    overflow: inherit;
    white-space: pre-line;
  }
  /deep/ .van-stepper__input {
    width: auto;
  }
  /deep/ .formily-element-array-table,
  /deep/ .formily-element-array-cards {
    width: 100%;
  }
  /deep/ .formily-vant-preview-input-title {
    width: auto;
  }
  /deep/ .van-field__label .van-cell::after {
    border: none;
  }
  /deep/ .van-field--disabled {
    background: #f7f8fa;
    transition: background 0.2s ease-out;
  }
  // 设计器“容器样式”字体颜色：vant 输入元素自身有显式 color，
  // 在容器设置了颜色（style 含 color）时让输入内容继承外层颜色
  /deep/ .van-field[style*="color:"] .van-field__control:not(:disabled) {
    color: inherit;
  }

  /deep/ .van-cell__value.van-field__value:has(.formily-element-array-table) {
    overflow: inherit;
  }
.enable-width-setting {
  // ===== ArrayTable / ArrayCards 内部输入框：title在第一行，description在第二行 =====
  /deep/ .formily-element-array-table,
  /deep/ .formily-element-array-cards {
    .van-field {
      flex-wrap: wrap;
      align-items: center;

      // title 和输入框在同一行（默认 order: 0）
      > .van-cell__title.van-field__label {
        flex: none;
        width: 6em;
        min-width: 6em;
        max-width: 6em;
      }

      // 输入框值区域在第一行
      > .van-cell__value.van-field__value {
        flex: 1;
        width: auto;
        min-width: 0;
      }

      // 图片上传和语音输入图标在第一行
      > .image-upload-input,
      > .voice-input-icon {
        flex-shrink: 0;
      }

      // description 独占第二行，自动换行
> .formily-vant-field-desc {
        order: 3;
        flex-basis: 100%;
        width: 100%;
        max-width: 100%;
        font-size: 12px;
        color: #969799;
        line-height: 16px;
        margin-top: 2px;
        // overflow-wrap: break-word;
        // word-break: break-all;
        white-space: pre-wrap;
      }
    }
  }



  /* ===== mobileCard（表格转卡片）内部输入框：title在第一行，description在第二行 ===== */
  /deep/ .mobileCard {
    .van-field {
      flex-wrap: wrap;
      align-items: center;

      // title 和输入框在同一行
      > .van-cell__title.van-field__label {
        flex: none;
        width: 6em;
        min-width: 6em;
        max-width: 6em;
      }

      // 输入框值区域在第一行
      > .van-cell__value.van-field__value {
        flex: 1;
        width: auto;
        min-width: 0;
      }

      // 图片上传和语音输入图标在第一行
      > .image-upload-input,
      > .voice-input-icon {
        flex-shrink: 0;
      }

      // description 独占第二行，自动换行
      > .formily-vant-field-desc {
        order: 3;
        flex-basis: 100%;
        width: 100%;
        max-width: 100%;
        font-size: 12px;
        color: #969799;
        line-height: 16px;
        margin-top: 2px;
        // overflow-wrap: break-word;
        // word-break: break-all;
        white-space: pre-wrap;
      }
    }
  }
}

    /deep/ .van-field {
    transition: background 0.2s ease-out;
  }
  /* 针对父级包含 mobileCard 类的元素特殊处理 */
  /* 当 mobileCard 只有一个子元素时 */
  /deep/ .mobileCard:has(> :only-child) .el-card__header {
    padding: 0.12rem 0.53rem;
  }
  
  /* 当 mobileCard 有多个子元素时 */
  /deep/ .mobileCard:not(:has(> :only-child)) .el-card__header {
    padding: 0.12rem 0.9rem;
  }
  
  /* 默认样式（兼容不支持 :has() 的浏览器） */
  /deep/ .mobileCard .el-card__header {
    padding: 0.12rem 0.9rem;
  }
  /deep/ .mobileCard .el-card__body {
    padding-top: 0;
    padding-bottom: 0;
  }
  /deep/ .mobileCard .van-field {
    transition: background 0.2s ease-out;
    flex-wrap: wrap !important;
    align-content: flex-start;
    align-items: flex-start;
  }
  /deep/ .mobileCard .el-row--flex.is-justify-space-between {
    align-items: center;
  }

  /deep/ .mobileCard .van-field__label {
    width: 100%;
  }

  /deep/ .mobileCard .van-cell__value {
    // flex: 1 1 auto;
    width: 100%;
    min-width: 0;
  }

  /deep/ .mobileCard .van-field__value {
    width: 100%;
  }

  /deep/ .mobileCard .van-cell {
    flex-wrap: wrap;
  }

  /deep/ .mobileCard .van-cell > * {
    // flex: 1 1 auto;
    box-sizing: border-box;
  }
  /deep/ .mobileCard .van-cell__title,
  /deep/ .mobileCard .van-cell__value {
    max-width: 100%;
    width: 100%;
  }
  /deep/ .mobileCard .van-field[style*='flex-wrap'] > *,
  /deep/ .mobileCard .van-field.flex-wrap > * {
    flex: 1 1 100% !important;
    width: 100% !important;
    margin-bottom: 8px;
  }
  /deep/ .mobileCard .van-stepper{
    display: flex;
  }
  /deep/ .mobileCardHorizontalVersion .van-stepper{
    display: flex;
  }
   /deep/ .mobileCardHorizontalVersion .van-stepper__input{
    width: 60%;
  }
  

  /* 如果需要针对包含 mobileCard 的 van-field 本身也设置样式 */
  /deep/ .van-field:has(.mobileCard) {
    flex-direction: column;
  }
  // 仅针对 Select (Picker) 组件的预览文本设置 padding 为 0
  /deep/ .van-field__control--custom .picker-preview-text.formily-vant-preview-text {
    padding: 0;
  }

  // ===== FormTab 同步 PC 端默认形式，并按 type 区分 line/card =====
  /deep/ .formily-element-form-tab {
    background: #ffffff;

    .van-tabs__nav {
      background: #ffffff;
    }

    .van-tab {
      color: var(--form-tab-title-font-color, #64748b) !important;
      font-size: 14px;
      font-weight: 500;
      background: #ffffff !important;
      transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1);

      .van-tab__text > div {
        color: var(--form-tab-title-font-color, #64748b) !important;
        font-weight: 500;
      }

      &:hover {
        color: #4096ff !important;
      }

      &:hover .van-tab__text > div {
        color: #4096ff !important;
      }

      &.van-tab--active,
      &.van-tab--active .van-tab__text {
        color: #1677ff !important;
        font-weight: 600 !important;
      }

      &.van-tab--active .van-tab__text > div {
        color: #1677ff !important;
        font-weight: 600;
      }

      &.van-tab--disabled {
        color: #c0c4cc !important;
      }

      &.van-tab--disabled .van-tab__text > div {
        color: #c0c4cc;
      }
    }
  }

  /deep/ .formily-element-form-tab--line {
    .van-tabs__wrap {
      height: 44px;
      border-bottom: 1px solid #e4e7ed;
    }

    .van-tabs__line {
      display: block;
      height: 3px;
      background-color: #1677ff;
      border-radius: 2px;
    }
  }

  /deep/ .formily-element-form-tab--card {
    .van-tabs__wrap {
      height: 44px;
      border-bottom: var(--form-tab-card-border-width, 1px) solid var(--form-tab-card-border-color, #e4e7ed);
    }

    .van-tabs__line {
      display: none;
    }

    .van-tabs__nav--card {
      height: 44px;
      margin: 0;
      overflow: hidden;
      background: #ffffff;
      border: var(--form-tab-card-border-width, 1px) solid var(--form-tab-card-border-color, #e4e7ed);
      border-bottom: none;
      border-radius: 4px 4px 0 0;

      .van-tab {
        color: var(--form-tab-title-font-color, #1e293b) !important;
        line-height: 42px;
        background: #ffffff !important;
        border-right: var(--form-tab-card-border-width, 1px) solid var(--form-tab-card-border-color, #e4e7ed);

        .van-tab__text > div {
          color: var(--form-tab-title-font-color, #1e293b) !important;
        }

        &:last-child {
          border-right: none;
        }

        &:hover {
          color: #4096ff !important;
        }

        &:hover .van-tab__text > div {
          color: #4096ff !important;
        }

&.van-tab--active {
          color: #1677ff !important;
          background: var(--form-tab-card-active-background, #ffffff) !important;
        }

        &.van-tab--active .van-tab__text > div {
          color: #1677ff !important;
        }
      }
    }
  }
}
</style>
<style lang="less">
.van-picker-column__item--selected {
  /* 重写选中后的效果 */
  .van-ellipsis {
    text-overflow: unset;
    overflow: visible;
    white-space: unset;
  }
}
.el-message-box {
  width: 300px !important;
}
.el-message {
  min-width: 300px !important;
}
</style>

